import { useFormik } from "formik";
import React, { useState } from "react";
import InputField from "../components/InputField";
import { carPurchaseSchema } from "../Schema/Schema";
import axios from "axios";
import { toast } from "react-toastify";

const CarPurchaseModel = ({ showModal, setShowModal, carTitle }) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      address: "",
    },
    validationSchema: carPurchaseSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const data = await axios.post(
          `${process.env.REACT_APP_MAIN_URL}carPurchase`,
          {
            ...values,
            carTitle,
          }
        );
        console.log("Form Values:", data);
        if (data.status === 200) {
          toast.success("Appointment booked successfully");
          setShowModal(false);
        }
        // resetForm();
      } catch (error) {
        console.log("Error:", error);
        toast.error(
          error?.response?.data?.status ||
            error?.message ||
            "Something went wrong. Please try again."
        );
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });
  return (
    <>
      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ zIndex: 1050 }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Book Car {carTitle}</h5>
                <button
                  onClick={() => setShowModal(false)}
                  style={{ padding: "15px 15px" }}
                  className="btn style2"
                >
                  ✖
                </button>
              </div>
              <div className="modal-body overflow-auto">
                <form onSubmit={formik.handleSubmit}>
                  <div className="row gy-3">
                    <div className="col-md-6">
                      <InputField
                        label="Enter First Name *"
                        name="firstName"
                        type="text"
                        placeholder="Enter First Name"
                        value={formik.values.firstName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.firstName}
                        error={formik.errors.firstName}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        label="Enter Last Name *"
                        name="lastName"
                        type="text"
                        placeholder="Enter Last Name"
                        value={formik.values.lastName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.lastName}
                        error={formik.errors.lastName}
                      />
                    </div>

                    <div className="col-md-6">
                      <InputField
                        label="Enter Email *"
                        name="email"
                        type="text"
                        placeholder="Enter Email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.email}
                        error={formik.errors.email}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        label="Enter Phone Number *"
                        name="phone"
                        type="text"
                        placeholder="Enter Phone Number"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.phone}
                        error={formik.errors.phone}
                      />
                    </div>
                    <div className="col-md-12">
                      <textarea
                        name="address"
                        className="form-control border-secondary"
                        onChange={formik.handleChange}
                        value={formik.values.address}
                      ></textarea>
                    </div>

                    <div className="">
                      <button
                        type="submit"
                        className="btn style2"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            BOOK APPOINTMENT
                          </>
                        ) : (
                          "BOOK APPOINTMENT"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default CarPurchaseModel;
